import {useEffect} from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'

const snapEngageFooterScript = (snapEngageWidgetID, proactiveChat, customerData) => {
    const {uid = '', firstName = '', lastName = '', customerId = ''} = customerData

    return `(function() {
        var se = document.createElement('script');
        se.type = 'text/javascript';
        se.async = true;
        se.src = '//storage.googleapis.com/code.snapengage.com/js/${snapEngageWidgetID}.js';

        var done = false;
        se.onload = se.onreadystatechange = function() {
            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                done = true;

                if (typeof SnapEngage !== 'undefined') {
                    SnapEngage.showButton();
                    SnapEngage.allowProactiveChat(${proactiveChat});
                    SnapEngage.setUserEmail("${uid}");
                    SnapEngage.setUserName("${firstName}");

                    SnapEngage.setCallback('Open', function () {
                        SnapEngage.setCustomField("CRM_name", "${firstName}");
                        SnapEngage.setCustomField("CRM_surname", "${lastName}");
                        SnapEngage.setCustomField("CRM_gigyaUid", "${customerId}");
                    });

                    ${
                        proactiveChat
                            ? `setTimeout(function () {
                                SnapEngage.openProactiveChat(false, false, 'Hey there, anything I can help you with?');
                            }, 3000);`
                            : ''
                    }
                }
            }
        };

        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(se, s);
    })();`
}

export const useSnapEngage = ({snapEngageWidgetID, proactiveChat}) => {
    const {data: customer} = useCurrentCustomer()

    const email = customer?.email || ''
    const firstName = customer?.firstName || ''
    const lastName = customer?.lastName || ''
    const customerId = customer?.customerId || ''
    const customerData = {uid: email, firstName, lastName, customerId}

    const setupFooterScript = () => {
        if (document.querySelector('[data-testid="snapengage-main-script"]') || window.SnapEngage)
            return
        const script = document.createElement('script')
        script.setAttribute('data-testid', 'snapengage-main-script')
        script.setAttribute('aria-hidden', 'true')
        script.setAttribute('data-aria-hidden', 'true')
        script.innerHTML = snapEngageFooterScript(snapEngageWidgetID, proactiveChat, customerData)
        document.body.appendChild(script)
    }

    useEffect(() => {
        if (snapEngageWidgetID) {
            setupFooterScript()
        }
    }, [snapEngageWidgetID, proactiveChat, customer])
}
